import * as Yup from "yup";
import {
  ImageFileFormats,
  MimeEnum,
  StaticImageFileFormats,
  VideoFileFormats,
  WavFileFormats,
} from "../../../common/commonEnums";
import { settings } from "../../../settings";
import {
  validateExtendedFileType,
  getImageValidationSchemaPart,
  validateExtendedFileSize,
} from "../../../helpers/validationHelper";
import { IExtendedFile } from "../../../common/commonTypes";

export const uploadTrackSchema = Yup.object().shape({
  masterWav: Yup.mixed()
    .required("form-error-master-wav-required")
    .test(
      "format",
      "form-error-not-wav",
      validateExtendedFileType(WavFileFormats)
    )
    .test(
      "size",
      "form-error-file-to-big",
      validateExtendedFileSize(settings.MAX_AUDIO_SIZE)
    ),
  masterMp3: Yup.mixed()
    .required("form-error-master-mp3-required")
    .test(
      "format",
      "form-error-not-mp3",
      validateExtendedFileType([MimeEnum.mp3])
    )
    .test(
      "size",
      "form-error-file-to-big",
      validateExtendedFileSize(settings.MAX_AUDIO_SIZE)
    ),
  cover: getImageValidationSchemaPart(
    settings.COVER_WIDTH,
    settings.COVER_WIDTH,
    settings.MAX_IMAGE_SIZE,
    [...ImageFileFormats, MimeEnum.mp4]
  ).required("form-error-cover-required"),
  // name is validated on component level to avoid unnecessary api calls
  countries: Yup.array()
    .of(Yup.string())
    .min(1, "form-error-country-required")
    .required("form-error-country-required"),
  description: Yup.string()
    .required("form-error-description-required")
    .max(1024, "form-error-description-max"),
  poster: getImageValidationSchemaPart(
    settings.TRACK_POSTER.WIDTH,
    settings.TRACK_POSTER.HEIGHT,
    settings.MAX_IMAGE_SIZE,
    StaticImageFileFormats,
    "form-error-not-static-image"
  ),
  instrumental: Yup.mixed()
    .test(
      "format",
      "form-error-not-wav",
      validateExtendedFileType(WavFileFormats)
    )
    .test(
      "size",
      "form-error-file-to-big",
      validateExtendedFileSize(settings.MAX_AUDIO_SIZE)
    ),
  vocals: Yup.mixed()
    .test(
      "format",
      "form-error-not-wav",
      validateExtendedFileType(WavFileFormats)
    )
    .test(
      "size",
      "form-error-file-to-big",
      validateExtendedFileSize(settings.MAX_AUDIO_SIZE)
    ),
  video: Yup.mixed()
    .test(
      "format",
      "form-error-not-video",
      validateExtendedFileType(VideoFileFormats)
    )
    .test(
      "size",
      "form-error-file-to-big",
      validateExtendedFileSize(settings.MAX_VIDEO_SIZE)
    ),
});

export const validateSingleFile = (field: string, value: IExtendedFile) =>
  Yup.reach(uploadTrackSchema, field).isValid(value);
